// extracted by css-extract-rspack-plugin
export default {"cover":"_WekIa","inner":"z01HIq","original":"Yjzpgd","blur":"R0W34p","title":"OspA6i","play":"B7ZhPv","main":"czgf_2","bg":"nBjpny","text":"WMZkc2","sub":"jJiINI"};